/**
 * Canonical environment columns, in deployment order (dev → prod). Shared by the
 * Secrets list (SecretsPage) and the Secret detail Keys table (SecretDetailPage)
 * so their env columns render in the SAME order and with the SAME titles.
 */
export const ENV_ORDER = ['dev', 'sandbox', 'qa', 'beta', 'prod'] as const;
export type EnvName = (typeof ENV_ORDER)[number];

// The scanners label the dev/local project inconsistently — instances carry
// 'local' while the GCP project maps to 'dev'. Treat them as one column ("Dev").
const ALIAS: Record<string, string> = { local: 'dev' };

/** Fold aliases + lowercase so both surfaces bucket an env the same way. */
export const normalizeEnv = (e: string): string => {
  const lc = e.toLowerCase();
  return ALIAS[lc] ?? lc;
};

/** Order a set of env names by ENV_ORDER (known first); unknowns alphabetical after. */
export function orderEnvs(envs: Iterable<string>): string[] {
  const rank = (e: string) => {
    const i = (ENV_ORDER as readonly string[]).indexOf(e);
    return i === -1 ? ENV_ORDER.length : i;
  };
  return [...new Set(envs)].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
}
